(function () {
  "use strict";

  var productSelector = '[data-section-type="product"]';

  function dispatchVariantEvent(container, eventName, variant) {
    container.dispatchEvent(
      new CustomEvent(eventName, {
        detail: { variant: variant },
      })
    );
  }

  function syncMasterSelect(container, variant) {
    var masterSelect = container.querySelector("[data-product-select]");

    if (!masterSelect || !variant || variant.id === undefined) {
      return false;
    }

    masterSelect.value = String(variant.id);
    return masterSelect.value === String(variant.id);
  }

  function syncSkuElement(container, variant) {
    var skuElement = container.querySelector("[data-sku]");
    var selectedSku = (variant && variant.sku) || "";

    if (!skuElement || skuElement.textContent.trim() === selectedSku) {
      return false;
    }

    skuElement.textContent = selectedSku;
    return true;
  }

  function getVariantFromSelectedOptions(container) {
    var variantsJson = container.querySelector("[data-variant-json]");
    var selectedOptions = {};
    var variants;

    if (!variantsJson) {
      return null;
    }

    container.querySelectorAll("[data-variant-input]").forEach(function (input) {
      var type = input.getAttribute("type");
      var index = input.dataset.index;

      if ((type === "radio" || type === "checkbox") && !input.checked) {
        return;
      }

      if (index) {
        selectedOptions[index] = input.value;
      }
    });

    try {
      variants = JSON.parse(variantsJson.value || variantsJson.textContent);
    } catch (error) {
      return null;
    }

    return (
      variants.find(function (variant) {
        return variant.options.every(function (optionValue, optionIndex) {
          var index = "option" + (optionIndex + 1);

          return (
            Object.prototype.hasOwnProperty.call(selectedOptions, index) &&
            selectedOptions[index] === optionValue
          );
        });
      }) || null
    );
  }

  function syncMasterSelectFromInputs(container) {
    var selectedVariant = getVariantFromSelectedOptions(container);

    if (selectedVariant) {
      syncMasterSelect(container, selectedVariant);
      syncSkuElement(container, selectedVariant);
    }
  }

  function syncDetailsAfterVariantChange(container, evt) {
    var variant = evt.detail && evt.detail.variant;
    var isInitialReplay = container.variantDetailSyncReplaying === true;

    if (!variant) {
      return;
    }

    var skuWasOutOfSync = syncSkuElement(container, variant);

    // variantChange is emitted before theme.js updates the hidden master
    // select. Keep it in sync immediately because that is the id submitted.
    syncMasterSelect(container, variant);

    // theme.js updates the variant details synchronously after variantChange.
    // Recheck afterwards so normal changes do not receive duplicate events.
    Promise.resolve().then(function () {
      // On the initial replay currentVariant already matches the checked
      // inputs, so theme.js skips its price equality checks.
      if (isInitialReplay) {
        dispatchVariantEvent(container, "variantPriceChange", variant);
        dispatchVariantEvent(container, "variantUnitPriceChange", variant);
      }

      if (isInitialReplay || skuWasOutOfSync) {
        dispatchVariantEvent(container, "variantSKUChange", variant);
      }
    });
  }

  function getSelectedVariantInput(container) {
    return (
      container.querySelector(
        '[data-field="sizeproducts"] input[data-variant-input]:checked'
      ) ||
      container.querySelector("input[data-variant-input]:checked") ||
      container.querySelector("select[data-variant-input]")
    );
  }

  function replaySelectedVariant(container) {
    if (!container || container.variantDetailSyncReplayed) {
      return;
    }

    var selectedInput = getSelectedVariantInput(container);

    if (!selectedInput) {
      return;
    }

    container.variantDetailSyncReplayed = true;
    container.variantDetailSyncReplaying = true;

    try {
      selectedInput.dispatchEvent(new Event("change", { bubbles: true }));
    } finally {
      container.variantDetailSyncReplaying = false;
    }
  }

  function initContainer(container) {
    if (!container || container.variantDetailSyncInitialized) {
      return;
    }

    container.variantDetailSyncInitialized = true;
    container.addEventListener(
      "change",
      function (evt) {
        if (evt.target && evt.target.matches("[data-variant-input]")) {
          syncMasterSelectFromInputs(container);
        }
      },
      true
    );
    container.addEventListener("variantChange", function (evt) {
      syncDetailsAfterVariantChange(container, evt);
    });
    container
      .querySelectorAll("form.product-single__form")
      .forEach(function (form) {
        form.addEventListener(
          "submit",
          function () {
            syncMasterSelectFromInputs(container);
          },
          true
        );
      });
  }

  function forEachProductSection(root, callback) {
    var scope = root || document;

    if (scope.matches && scope.matches(productSelector)) {
      callback(scope);
    }

    if (!scope.querySelectorAll) {
      return;
    }

    scope.querySelectorAll(productSelector).forEach(callback);
  }

  function initProductSections(root) {
    forEachProductSection(root, initContainer);
  }

  function initAndReplayProductSections(root) {
    initProductSections(root);
    forEachProductSection(root, replaySelectedVariant);
  }

  initProductSections(document);
  document.addEventListener("page:loaded", function () {
    initAndReplayProductSections(document);
  });
  document.addEventListener("shopify:section:load", function (evt) {
    setTimeout(function () {
      initAndReplayProductSections(evt.target);
    }, 0);
  });
  document.addEventListener("quickview:loaded", function () {
    setTimeout(function () {
      initAndReplayProductSections(document);
    }, 0);
  });

  if (document.readyState === "complete") {
    setTimeout(function () {
      initAndReplayProductSections(document);
    }, 0);
  }
})();
